import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import logo from '../components/login/img/onlineMall-logo.png';
import styles from '../components/login/login.module.less';

const { Header, Content } = Layout;

function LoginLayout(props) {
  return (
    <Layout className={styles.layoutWrap}>
      <Header className={styles.header}>
        <div className={styles.logo}>
          <img alt="logo" src={logo} height={48} />
        </div>
      </Header>
      <Content className={styles.content}>{props.children}</Content>
      {/*<FooterCustom className={styles.footer} />*/}
    </Layout>
  );
}

LoginLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

LoginLayout.defaultProps = {};

export default LoginLayout;
